import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";

export class BringozCustomMultiSelectComponent implements IController {

  formName?: string;
  selectedValues: any;
  options: any;
  optionsWrapper: any;
  ngPlaceholder: any;
  excludeOptions: any;
  optionsPrefix: string;
  isDisabled: any;
  isRequired: boolean;
  isOrderedOptions: boolean;
  selectParams: any;
  onChange: Function;

  public selectedText: any;

  constructor(private $mdPanel, private $element, private $filter) {
  }

  $onInit() {
    this._setFormName();
    this._setSelectedText();
  };

  $onChanges(changes) {
    if (changes.selectedValues && !changes.selectedValues.isFirstChange()) {
      this._setSelectedText();
    }
    if (changes.formName && !changes.formName.isFirstChange()) {
      this._setFormName();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedValues || [];
    const optionsRef = this.options;
    const optionsWrapperRef = this.optionsWrapper;
    const excludeIdsRef = this.excludeOptions;
    const ngPlaceholderRef = this.ngPlaceholder;
    const isOrderedOptionsRef = this.isOrderedOptions;
    const optionsPrefixRef = this.optionsPrefix;
    const selectParamsRef = this.selectParams;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'options-wrapper="ctrl.optionsWrapperRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'is-ordered-options="ctrl.isOrderedOptionsRef"' +
        'select-params="ctrl.selectParamsRef"' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'options-prefix="{{ctrl.optionsPrefixRef}}" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'custom';
        this.selectedIdsRef = selectedIdsRef;
        this.optionsRef = optionsRef;
        this.optionsWrapperRef = optionsWrapperRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
        this.isOrderedOptionsRef = isOrderedOptionsRef;
        this.selectParamsRef = selectParamsRef;
        this.optionsPrefixRef = optionsPrefixRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        if (!selectedIds?.length) {
          this.onChange({values: []});
        } else {
          this.onChange({values: selectedIds});
        }
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({values: []});
  }

  private _setSelectedText() {
    let string = '';
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext("2d");

    _.forEach(this.selectedValues, (v, i) => {
      let name;
      if (this.optionsWrapper) {
        name = this.optionsWrapper.list.find(item => item.id === v)[this.optionsWrapper.propertyRef];
      } else {
        name = v;
      }
      if (this.optionsPrefix) {
        string += this.$filter('translate')(this.optionsPrefix + '.' + name);
      } else {
        string += this.$filter('translate')(name);
      }

      if ((i + 1) < this.selectedValues.length) {
        string += ', ';
      }
    });

    const stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 10) >= (this.$element[0].clientWidth - 30)) {
      string = '';

      let name;
      if (this.optionsWrapper) {
        name = this.optionsWrapper.list[0][this.optionsWrapper.propertyRef];
      } else {
        name = this.selectedValues[0];
      }

      if (this.optionsPrefix) {
        string += this.$filter('translate')(this.optionsPrefix + '.' + name);
      } else {
        string += this.$filter('translate')(name);
      }

      if (this.selectedValues.length - 1) {
        string += ` +${this.selectedValues.length - 1}`;
      }
    }

    this.selectedText = string;
  }


  private _setFormName() {
    if (!this.formName) {
      this.formName = "enumSelect"
    }
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozCustomMultiSelect', {
    require: {
      form: '^form'
    },
    bindings: {
      formName: '<?',
      selectedValues: '<?',
      options: '<?',
      optionsWrapper: '<?',
      excludeOptions: '<?',
      isRequired: '<?',
      isOrderedOptions: '<?',
      selectParams: '<?',
      ngPlaceholder: '@?',
      optionsPrefix: '@?',
      isDisabled: '<?',
      onChange: '&'
    },
    template: require('./bringoz-custom-multi-select.html').default,
    controller: BringozCustomMultiSelectComponent
  });
